import React from 'react';
import { styled } from 'styled-components';
import { bp } from '../../../styles/breakPoints.tsx';
import { Color, Image } from '../../types.ts';
import ResizedImage from '../ResizedImage.tsx';

const Wrapper = styled.div<{ $backgroundColor: Color; $textColor: Color }>`
  display: flex;
  gap: 16px;
  flex-direction: column-reverse;

  @media ${bp.md} {
    flex-direction: row;
  }

  .box {
    background-color: ${({ $backgroundColor }) => $backgroundColor.css ?? 'green'};
    color: ${({ $textColor }) => $textColor.rgba ?? 'white'};
    padding: 24px;
    border-radius: 16px;
    line-height: 29px;

    @media ${bp.md} {
      width: 70%;
      padding: 32px 24px;
    }
  }

  .image-container {
    display: flex;
    justify-content: center;
    border-radius: 16px;
    overflow: hidden;

    max-height: 400px;

    @media ${bp.md} {
      width: 30%;
    }

    img {
      object-fit: cover;
      object-position: top;
    }
  }
`;
interface b2bProductsHeroProps {
  fieldValues: {
    box_background_color: Color;
    box_text_color: Color;
    main_image: Image;
    box_content: string;
  }
}

function b2bProductsHero(props: b2bProductsHeroProps) {
  const { fieldValues } = props;
  const { main_image, box_content, box_background_color, box_text_color } = fieldValues;

  return (
    <>
      <Wrapper $backgroundColor={box_background_color} $textColor={box_text_color}>
        <div className='box'>
          <div dangerouslySetInnerHTML={{ __html: box_content }} />
        </div>
        <div className='image-container'>
          <ResizedImage src={main_image.src} alt={main_image.alt} mobileWidth={300} desktopWidth={300} loading='eager' />
        </div>
      </Wrapper>
    </>
  );
}

export default b2bProductsHero;
